import React from 'react';
import CampaignPropertyReservationPriceCell from './CampaignPropertyReservationPriceCell';
import RequestCell from './RequestCell';

export const columnDefinition = (
    requestClick,
    campaignProperties = [],
    readOnly
) => {
    const style = { height: 34, padding: '0 11px' };
    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 6,
            headerName: 'Property Name',
            field: 'name',
            type: 'text',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: '',
            isSticky: true
        },
        {
            displayOrder: 7,
            headerName: 'Type',
            field: 'type',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 8,
            headerName: 'First Episode',
            field: 'firstEpisodeDate',
            type: 'date',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 9,
            headerName: 'Last Episode',
            field: 'lastEpisodeDate',
            type: 'date',
            width: 150,
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 10,
            headerName: 'Episodes',
            field: 'numberOfEpisode',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 11,
            headerName: 'Spots',
            field: 'numberOfSpot',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 12,
            headerName: 'Reach', // ToDo: make it percentage
            field: 'cumulativeReach',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 13,
            headerName: 'Impacts',
            field: 'cumulativeImpacts',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 14,
            headerName: 'OTH',
            field: 'cumulativeOth',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 16,
            headerName: 'Total Booked',
            field: 'totalBooked',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 17,
            headerName: 'Total Reserved',
            field: 'totalReserved',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 18,
            headerName: 'Total Available',
            field: 'totalAvailable',
            type: 'number',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 19,
            headerName: 'Book Price',
            field: 'price',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 20,
            headerName: 'Reservation Price',
            field: 'reservationPrice',
            type: 'custom',
            customType: 'component',
            component: (
                <CampaignPropertyReservationPriceCell
                    campaignProperties={campaignProperties}
                />
            ),
            width: 'auto',
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 21,
            headerName: 'Reservation Request',
            field: 'reservedStatus',
            type: 'custom',
            customType: 'component',
            component: (
                <RequestCell
                    onComponentClick={requestClick}
                    campaignProperties={campaignProperties}
                    readOnly={readOnly}
                />
            ),
            width: 50,
            hideInColumnFilter: true,
            showInList: true,
            sortable: false
        }
    ];
};
